﻿var jquery = require("jquery");
var HabEvents = require('./habitaclia-events');
var storageService = require( '../Global/storage-service').default;

export default class LeadCounter {

    constructor()
    {
        this.attempts = 0;
        this.registerEvents();
    }

    registerEvents()
    {
        jquery.subscribe(HabEvents.EventsEnum.ErrorAvisoLegal, ()=>this.attempts++);
        jquery.subscribe(HabEvents.EventsEnum.ConfirmacionSolicitudEnviada, ()=>{
            jquery.publish(HabEvents.EventsEnum.RecuentoIntentosSolicitud, [this.attempts]);
        });
    }
}

/* jshint unused: false */
const leadCounterInstance = new LeadCounter();